import { clamp } from "./globe-projection";
import type { GlobePalette, Rgba } from "./globe-render-types";

/** `#rrggbb`, `rgb(…)` and `rgba(…)`: the forms the themes use. */
export function parseColor(value: string): Rgba {
  const hex = /^#([0-9a-f]{3,8})$/i.exec(value.trim())?.[1];
  if (!hex) {
    const [r = 128, g = 128, b = 128, a = 1] = (
      value.match(/-?[\d.]+/g) ?? []
    ).map(Number);
    return { r, g, b, a };
  }
  const full =
    hex.length <= 4 ? [...hex].map((digit) => digit + digit).join("") : hex;
  const [r = 128, g = 128, b = 128, a = 255] = (full.match(/../g) ?? []).map(
    (pair) => parseInt(pair, 16),
  );
  return { r, g, b, a: a / 255 };
}
export const rgba = (color: Rgba, alpha: number) =>
  `rgba(${color.r}, ${color.g}, ${color.b}, ${clamp(color.a * alpha, 0, 1).toFixed(3)})`;
/** The canvas's text, muted and warning colours; a missing variable (tests) reads as mid grey. */
export function readPalette(element: Element): GlobePalette {
  const style = getComputedStyle(element);
  const read = (name: string) =>
    parseColor(style.getPropertyValue(name).trim() || "rgb(128, 128, 128)");
  return {
    ink: read("--color-primary"),
    muted: read("--color-muted"),
    amber: read("--color-warning"),
    accent: read("--color-accent"),
  };
}
